export default function* rootSaga() {}
